import React, { Fragment } from 'react';
import {
	chkMobile,
	formatProgramDate,
	generateTimeSlotsTen,
	getConvertMinutes,
	getHallName,
	insertEmptyProgramsTen,
	noneFilter,
} from '../js/calculator';

const TimeTableTen = ({
	lang,
	programList,
	selectFirstDay,
	setSelectFirstDay,
	selectSecondDay,
	setSelectSecondDay,
	hallId,
	setHallId,
	onFloat,
	onLive,
	clickLive,
	programListLength,
	programPop,
	setProgramPop,
	popContents,
	setPopContents,
	getSpeakerNames,
	getVideopopData,
	isTrack,
	openSpeaker,
	openModerator,
	toggleClose,
	videoData,
	toggleOpen,
	videoPop,
	onEng,
	setOnEng,
	onKor,
	setOnKor,
	setPopUuid,
	popClose,
}) => {
	const filteredSpeakers = num => {
		return popContents?.speakerInfoDtos?.filter(el => el?.speakerType === num) || [];
	};
	return (
		<div className="schedule-all-wrapper">
			<div className="link_tab">
				<div className="inner">
					<ul className="program-top-wrapper">
						<li
							className={selectFirstDay ? 'active1' : ''}
							onClick={() => {
								setSelectFirstDay(!selectFirstDay);
								setSelectSecondDay(!selectSecondDay);
								setHallId(0);
							}}
						>
							<a>{formatProgramDate(programList?.firstDay)}</a>
						</li>
						<li
							className={selectSecondDay ? 'active1' : ''}
							onClick={() => {
								setSelectFirstDay(!selectFirstDay);
								setSelectSecondDay(!selectSecondDay);
								setHallId(0);
							}}
						>
							<a>{formatProgramDate(programList?.secondDay)}</a>
						</li>
					</ul>
				</div>
			</div>
			{/* <div className="tab_menu mobile">
        <ul>
          {programList !== undefined && programList?.trackList?.map((ele, idx) => {
            return <li className={idx === hallId ? 'active' : ''} key={idx}
              onClick={() => {
                if (isMobile) {
                  setHallId(idx);
                  if (idx === hallId) {
                    document.getElementById(`program_group_${idx + 1}`).style.display === 'block'
                  }
                }
              }}>
              <a>{`Track${idx + 1}`}<em>{getHallName(idx)}</em></a>
            </li>
          }
          )}
        </ul>
      </div> */}
			<div className="schedule_table">
				<div id="schedule_group" className="schedule_2019_wrap">
					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track1 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 1</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 1 (Dynasty Hall)' : '미팅룸 1 (다이너스티)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track1 === undefined
													? null
													: ele?.track1?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track2 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 2</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 2 (Ruby Hall)' : '미팅룸 2 (루비)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track2 === undefined
													? null
													: ele?.track2?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track3 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 3</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 3 (Topaz Hall)' : '미팅룸 3 (토파즈)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track3 === undefined
													? null
													: ele?.track3?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track4 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 4</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 4 (Emerald Hall)' : '미팅룸 4 (에메랄드)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track4 === undefined
													? null
													: ele?.track4?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track5 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 5</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 5 (Lilac Hall)' : '미팅룸 5 (라일락)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track5 === undefined
													? null
													: ele?.track5?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track6 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 6</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 6 (Orchid Hall)' : '미팅룸 6 (오키드)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track6 === undefined
													? null
													: ele?.track6?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}

					{programList !== undefined &&
						programList?.trackList?.map((element, getId) =>
							element?.track7 === undefined ? null : (
								<div className="schedule_2019" key={getId}>
									<div className="sch_track">
										<div className="sch_track_item">Track 7</div>
										<div className="sch_track_item">
											{lang === 'en' ? 'Meeting Room 7 (Aston House)' : '미팅룸 7 (애스톤하우스)'}
										</div>
										<div className="sch_track_item"></div>
									</div>
									<table>
										<colgroup>
											<col></col>
											<col></col>
											<col></col>
										</colgroup>
										{programList !== undefined &&
											programList?.trackList?.map((ele, idx) =>
												ele?.track7 === undefined
													? null
													: ele?.track7?.map((el, id) => (
															<tbody key={id}>
																<tr className="schedule_2019_item">
																	<td className="time">
																		{el?.startTime}~{el?.endTime}
																	</td>
																	<td
																		onClick={() => {
																			setProgramPop(true);
																			sessionStorage.setItem('programPop', 'true');
																			document.body.style.overflow = 'hidden';
																			setPopContents({
																				startTime: el?.startTime,
																				endTime: el?.endTime,
																				programContent: el?.programContent,
																				programName: el?.programName,
																				speakerInfoDtos: el?.speakerInfoDtos,
																			});
																		}}
																	>
																		<a className="tt open_modal">
																			{el?.programName}
																			<span>{getSpeakerNames(el?.speakerInfoDtos, lang)}</span>
																		</a>
																	</td>
																	{el?.videoSt === '3' && (
																		<td
																			onClick={() => {
																				getVideopopData(el?.programId);
																			}}
																			style={{ cursor: 'pointer' }}
																		>
																			<a className="vod_btn open_video_modal">VOD</a>
																		</td>
																	)}
																</tr>
															</tbody>
														)),
											)}
									</table>
								</div>
							),
						)}
				</div>
			</div>
			{programPop && (
				<>
					<div className="schedule_pop info_modal open">
						<div className="close_pop_wrap">
							<div
								className="close_pop"
								onClick={() => {
									setProgramPop(false);
									document.body.style.overflow = 'auto';
									toggleClose();
									sessionStorage.setItem('programPop', 'false');
								}}
							>
								<div className="modal_cont_wrap mCustomScrollbar _mCS_9 mCS-autoHide mCS_no_scrollbar">
									<img src="//news.chosun.com/myj/alc_timetable/img/close-active.png" />
								</div>
							</div>
						</div>
						<div className="inner">
							<div className="modal_cont_wrap">
								<div className="cont_top">
									<div className="modal_time">{`${popContents?.startTime}~${popContents?.endTime}`}</div>
									<div className="modal_title">{popContents?.programName}</div>
									<div className="modal_desc">{popContents?.programContent}</div>
								</div>
								<div className="seperate-line"></div>
								<div className="" style={{ display: 'flex', flexDirection: 'column' }}>
									<span className="info-title">{lang === 'en' ? 'Participants':'참여자 정보'}</span>
									{filteredSpeakers(2).length > 0 && (
										<div className="cont_bot border-grey">
											<div className="modal_sm_title">{lang === 'en' ? 'Moderator' : '좌장'}</div>
											{filteredSpeakers(2).map((ele, idx) => {
												return (
													<div
														id={`grey-${idx}`}
														key={idx}
														className={`speaker_info ${idx === 0 ? 'first' : ''} ${openModerator === idx ? 'open' : ''}`}
													>
														<div className="dis_table">
															<div className="img">
																<span>
																	<img src={ele?.speakerImg} alt="" />
																</span>
															</div>
															<div className="txt">
																<div className="txt1">
																	{lang === 'en' ? ele?.speakerNmEn : ele?.speakerNmKr}
																</div>
																<div className="txt2">
																	{lang === 'en' ? ele?.speakerBelongEn : ele?.speakerBelongKr}
																</div>
															</div>
														</div>
														{idx === openModerator ? (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(2, idx);
																}}
															>
																<span>{lang === 'en' ? 'Less' : '접기'}</span>
															</span>
														) : (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(2, idx);
																}}
															>
																<span>{lang === 'en' ? 'More' : '더보기'}</span>
															</span>
														)}
														<div className={lang === 'en' ? 'grey_box' : 'grey_box kor'}>
															{lang === 'en' ? ele?.introEn : ele?.introKr}
														</div>
													</div>
												);
											})}
										</div>
									)}
									{filteredSpeakers(1).length > 0 && (
										<div className="cont_bot second-section">
											<div className="modal_sm_title">{lang === 'en' ? 'Speaker' : '연사'}</div>
											{filteredSpeakers(1).map((ele, idx) => {
												return (
													<div
														id={`grey-${idx}`}
														key={idx}
														className={`speaker_info ${idx === 0 ? 'first' : ''} ${openSpeaker === idx ? 'open' : ''}`}
													>
														<div className="dis_table">
															<div className="img">
																<span>
																	<img src={ele?.speakerImg} alt="" />
																</span>
															</div>
															<div className="txt">
																<div className="txt1">
																	{lang === 'en' ? ele?.speakerNmEn : ele?.speakerNmKr}
																</div>
																<div className="txt2">
																	{lang === 'en' ? ele?.speakerBelongEn : ele?.speakerBelongKr}
																</div>
															</div>
														</div>
														{idx === openSpeaker ? (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(1, idx);
																}}
															>
																<span>{lang === 'en' ? 'Less' : '접기'}</span>
															</span>
														) : (
															<span
																className="more"
																onClick={() => {
																	toggleOpen(1, idx);
																}}
															>
																<span>{lang === 'en' ? 'More' : '더보기'}</span>
															</span>
														)}
														<div className={lang === 'en' ? 'grey_box' : 'grey_box kor'}>
															{lang === 'en' ? ele?.introEn : ele?.introKr}
														</div>
													</div>
												);
											})}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
					<div
						className="schedule_pop_2024_bg"
						onClick={() => {
							setProgramPop(false);
							document.body.style.overflow = 'auto';
							toggleClose();
							sessionStorage.setItem('programPop', 'false');
						}}
					></div>
				</>
			)}
			{noneFilter.includes(videoData) === false && videoPop && (
				<div id="speaker_pop_wrapper fadeIn" className="layer-wrap speaker_pop_wrap">
					<div className="speaker_pop">
						<ul className="lang_btn">
							{videoData?.uuidEn !== '' && (
								<li
									onClick={() => {
										setOnEng(true);
										setOnKor(false);
										setPopUuid(videoData?.uuidEn);
									}}
								>
									<span className={onEng ? 'on' : ''}>ENG</span>
								</li>
							)}
							{videoData?.uuidKr !== '' && (
								<li
									onClick={() => {
										setOnEng(false);
										setOnKor(true);
										setPopUuid(videoData?.uuidKr);
									}}
								>
									<span className={onKor ? 'on' : ''}>KOR</span>
								</li>
							)}
						</ul>
						<div
							className="btn-layerClose"
							onClick={() => {
								popClose();
							}}
						></div>
						<div id="lang_en" className={`tab_cont tab_on_video`}>
							<div className="video_area">
								<div
									className="powa"
									id={`powa-${onEng ? videoData?.uuidEn : videoData?.uuidKr}`}
									data-uuid={onEng ? videoData?.uuidEn : videoData?.uuidKr}
									data-org="chosun"
									data-api="prod"
									data-env="prod"
								></div>
							</div>
							<div className="video_pop_title">
								<div className="cate">{onEng ? videoData?.categoryEn : videoData?.categoryKr}</div>
								<div className="tt">{onEng ? videoData?.videoNameEn : videoData?.videoNameEn}</div>
							</div>
							<div className="video_pop_speaker">
								<div className="modal_sm_title">{onEng ? 'Speaker' : '연사'}</div>
								{videoData?.speakerResponseList?.map((ele, idx) => (
									<div className={`speaker_info ${idx === 0 ? 'first' : ''}`} key={idx}>
										<div className="dis_table">
											<div className="img">
												<span>
													<img src={ele?.speakerImg} alt="" className="mCS_img_loaded" />
												</span>
											</div>
											<div className="txt">
												<div className="txt1">{onEng ? ele?.speakerNmEn : ele?.speakerNmKr}</div>
												<div className="txt2">
													{onEng ? ele?.speakerBelongEn : ele?.speakerBelongKr}
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default TimeTableTen;
